import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  producer: null,
  producers: []
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
